module.exports = __webpack_public_path__ + "img/1000-1_SERF_2022_Kimberly-Icon.5d5e84f3.png";